import { api } from "./api";
import { getAdminToken } from "./admin";

/* ---------- Public ---------- */
export const listIndustries = async () => (await api.get("/portfolio/industries")).data;
export const listPhotos = async ({ industry, product_tag } = {}) => {
  const params = {};
  if (industry) params.industry = industry;
  if (product_tag) params.product_tag = product_tag;
  return (await api.get("/portfolio/photos", { params })).data;
};
export const listProducts = async () => (await api.get("/portfolio/products")).data;
export const getProductDetail = async (slug) => (await api.get(`/portfolio/product/${slug}`)).data;

/* ---------- Admin ---------- */
const adminHeaders = () => ({ headers: { "X-Admin-Password": getAdminToken() || "" } });

export const adminListPhotos = async () =>
  (await api.get("/admin/portfolio/photos", adminHeaders())).data.items || [];

export const adminGetSettings = async () =>
  (await api.get("/admin/portfolio/settings", adminHeaders())).data;

export const adminUpdateSettings = async (patch) =>
  (await api.put("/admin/portfolio/settings", patch, adminHeaders())).data;

export const adminSyncDrive = async () =>
  (await api.post("/admin/portfolio/sync", {}, adminHeaders())).data;

export const adminUpdatePhoto = async (id, patch) =>
  (await api.patch(`/admin/portfolio/photos/${id}`, patch, adminHeaders())).data;

export const adminDeletePhoto = async (id) =>
  (await api.delete(`/admin/portfolio/photos/${id}`, adminHeaders())).data;

export const adminCreatePhoto = async (payload) =>
  (await api.post("/admin/portfolio/photos", payload, adminHeaders())).data;

export const adminUploadPhotos = async (files, onProgress, opts = {}) => {
  const fd = new FormData();
  for (const f of files) fd.append("files", f);
  const params = {};
  if (opts.projectName) params.project_name = opts.projectName;
  if (opts.projectDescription) params.project_description = opts.projectDescription;
  if (opts.projectId) params.project_id = opts.projectId;
  const res = await api.post("/admin/portfolio/photos/upload", fd, {
    headers: {
      ...adminHeaders().headers,
      "Content-Type": "multipart/form-data",
    },
    params,
    onUploadProgress: (evt) => {
      if (onProgress && evt.total) onProgress(Math.round((evt.loaded * 100) / evt.total));
    },
  });
  return res.data;
};

/* ---------- Project (album) CRUD ---------- */
export const adminListProjects = async () =>
  (await api.get("/admin/portfolio/projects", adminHeaders())).data.items || [];

export const adminCreateProject = async (payload) =>
  (await api.post("/admin/portfolio/projects", payload, adminHeaders())).data;

export const adminUpdateProject = async (id, patch) =>
  (await api.patch(`/admin/portfolio/projects/${id}`, patch, adminHeaders())).data;

export const adminDeleteProject = async (id, { deleteMedia = false } = {}) =>
  (await api.delete(`/admin/portfolio/projects/${id}`, {
    ...adminHeaders(),
    params: { delete_media: deleteMedia },
  })).data;

export const adminAssignPhotosToProject = async (id, photoIds) =>
  (await api.post(`/admin/portfolio/projects/${id}/photos`, { photo_ids: photoIds }, adminHeaders())).data;

export const adminRemovePhotoFromProject = async (projectId, photoId) =>
  (await api.delete(`/admin/portfolio/projects/${projectId}/photos/${photoId}`, adminHeaders())).data;

export const adminSetProjectCover = async (projectId, photoId) =>
  (await api.post(`/admin/portfolio/projects/${projectId}/cover/${photoId}`, {}, adminHeaders())).data;

export const fetchPublicProject = async (projectId) =>
  (await api.get(`/portfolio/project/${projectId}`)).data;

/* ---------- Product Tag CRUD ---------- */
export const adminCreateProductTag = async (payload) =>
  (await api.post("/admin/portfolio/product-tags", payload, adminHeaders())).data;

export const adminUpdateProductTag = async (name, patch) =>
  (await api.patch(`/admin/portfolio/product-tags/${encodeURIComponent(name)}`, patch, adminHeaders())).data;

export const adminDeleteProductTag = async (name) =>
  (await api.delete(`/admin/portfolio/product-tags/${encodeURIComponent(name)}`, adminHeaders())).data;

/* ---------- Industry CRUD ---------- */
export const adminCreateIndustry = async (payload) =>
  (await api.post("/admin/portfolio/industries", payload, adminHeaders())).data;

export const adminUpdateIndustry = async (slug, patch) =>
  (await api.patch(`/admin/portfolio/industries/${encodeURIComponent(slug)}`, patch, adminHeaders())).data;

export const adminDeleteIndustry = async (slug) =>
  (await api.delete(`/admin/portfolio/industries/${encodeURIComponent(slug)}`, adminHeaders())).data;
